import { render, staticRenderFns } from "./SupportTooltip.vue?vue&type=template&id=e48a1db0&scoped=true"
import script from "./SupportTooltip.vue?vue&type=script&lang=js"
export * from "./SupportTooltip.vue?vue&type=script&lang=js"
import style0 from "./SupportTooltip.vue?vue&type=style&index=0&id=e48a1db0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48a1db0",
  null
  
)

export default component.exports